import { render, staticRenderFns } from "./BatchClientsEdit.vue?vue&type=template&id=315d784c&scoped=true"
import script from "./BatchClientsEdit.vue?vue&type=script&lang=js"
export * from "./BatchClientsEdit.vue?vue&type=script&lang=js"
import style0 from "./BatchClientsEdit.vue?vue&type=style&index=0&id=315d784c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315d784c",
  null
  
)

export default component.exports